// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetAppLogsRequestModel from '../../model/get-app-logs-request-model';
import GetAppLogsRequestDTO from '../dto/get-app-logs-request-dto';
import dtoSchema from '../schemas/get-app-logs-request-schema';

export default abstract class GetAppLogsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetAppLogsRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.dateFrom = data.dateFrom;
      this.dateTo = data.dateTo;
      this.levels = data.levels;
      this.correlationId = data.correlationId;
      this.appTransactionId = data.appTransactionId;
      this.appUserId = data.appUserId;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {date-time}
  */
  dateFrom?: string;
  /**
  * @type {date-time}
  */
  dateTo?: string;
  /**
  */
  levels?: string[];
  /**
  */
  correlationId?: string;
  /**
  */
  appTransactionId?: string;
  /**
  * @type {int64}
  */
  appUserId?: number;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetAppLogsRequestDTO>): GetAppLogsRequestModel;
  static toModel(dto: DeepPartial<GetAppLogsRequestDTO> | undefined | null): GetAppLogsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetAppLogsRequestDTO> | undefined | null): GetAppLogsRequestModel | undefined {
    return dto ? new GetAppLogsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetAppLogsRequestModel> | GetAppLogsRequestModel): GetAppLogsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      dateFrom: unwrapped.dateFrom,
      dateTo: unwrapped.dateTo,
      levels: unwrapped.levels,
      correlationId: unwrapped.correlationId,
      appTransactionId: unwrapped.appTransactionId,
      appUserId: unwrapped.appUserId,
      searchCriteria: unwrapped.searchCriteria,
    } as GetAppLogsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetAppLogsRequestModel, can not map to GetAppLogsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
